if (!customElements.get('discount-end-label')) {
  // One clock for all cards, PDPs and drawer instances, including AJAX inserts.
  const labels = new Set();
  let interval;
  const stopClock = (label) => {
    labels.delete(label);
    if (!labels.size && interval) {
      clearInterval(interval);
      interval = undefined;
    }
  };
  const tick = () => {
    const now = Date.now();
    labels.forEach((label) => label.update(now));
  };

  class DiscountEndLabel extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.label = this.querySelector('.product-label--discount-end');
      try {
        this.variantSchedules = JSON.parse(this.dataset.variantSchedules || '{}');
        this.productSchedule = JSON.parse(this.dataset.productSchedule || 'null');
      } catch (error) {
        return;
      }
      this.scope = this.closest('product-card, .js-product');
      this.onVariantChange = (event) => this.selectVariant(event.detail?.variant?.id);
      this.onSwatchChange = (event) => {
        if (event.target.matches('.opt-btn[data-variant-id]')) {
          this.selectVariant(event.target.dataset.variantId);
        }
      };
      this.scope?.addEventListener('on:variant:change', this.onVariantChange);
      this.scope?.addEventListener('change', this.onSwatchChange);
      this.selectVariant(this.scope?.dataset.pendingVariantId || this.dataset.variantId);
    }

    disconnectedCallback() {
      stopClock(this);
      this.scope?.removeEventListener('on:variant:change', this.onVariantChange);
      this.scope?.removeEventListener('change', this.onSwatchChange);
    }

    selectVariant(variantId) {
      stopClock(this);
      this.hidden = true;
      const schedule = variantId
        ? this.variantSchedules[variantId] || this.productSchedule
        : null;
      const { start_at: startAt = '', end_at: endAt = '' } = schedule || {};
      this.dataset.variantId = variantId || '';
      this.dataset.startAt = startAt;
      this.dataset.endAt = endAt;
      // Never interpret timezone-less values in the visitor's local timezone.
      const zonedDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
      this.startsAt = zonedDate.test(startAt) ? Date.parse(startAt) : NaN;
      this.endsAt = zonedDate.test(endAt) ? Date.parse(endAt) : NaN;
      if (!this.label || !Number.isFinite(this.startsAt) || !Number.isFinite(this.endsAt)
        || this.endsAt <= this.startsAt) return;

      const now = Date.now();
      this.update(now);
      if (now >= this.endsAt) return;
      labels.add(this);
      if (!interval) interval = setInterval(tick, 1000);
    }

    update(now) {
      this.hidden = now < this.startsAt || now >= this.endsAt;
      if (now >= this.endsAt) {
        stopClock(this);
        return;
      }
      if (this.hidden) return;

      const totalSeconds = Math.ceil((this.endsAt - now) / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor(totalSeconds % 86400 / 3600);
      const minutes = Math.floor(totalSeconds % 3600 / 60);
      const seconds = totalSeconds % 60;
      const clock = [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');
      const dayText = (this.dataset.dayTemplate || '[count]d').replace('[count]', String(days));
      const time = days ? `${dayText} ${clock}` : clock;
      this.label.textContent = (this.dataset.labelTemplate || 'Ends in [time]').replace('[time]', time);
    }
  }

  customElements.define('discount-end-label', DiscountEndLabel);
}
